import { ref, reactive } from 'vue'

// Estado global reativo para títulos customizados do breadcrumb
const customTitles = reactive({})

export function useBreadcrumbTitle() {
  /**
   * Define um título customizado para uma rota específica
   * @param {string} path - O caminho da rota
   * @param {string} title - O título a ser exibido no breadcrumb
   */
  const setBreadcrumbTitle = (path, title) => {
    customTitles[path] = title
  }

  /**
   * Remove um título customizado para uma rota específica
   * @param {string} path - O caminho da rota
   */
  const removeBreadcrumbTitle = (path) => {
    delete customTitles[path]
  }

  /**
   * Limpa todos os títulos customizados
   */
  const clearBreadcrumbTitles = () => {
    Object.keys(customTitles).forEach(key => {
      delete customTitles[key]
    })
  }

  return {
    customTitles,
    setBreadcrumbTitle,
    removeBreadcrumbTitle,
    clearBreadcrumbTitles
  }
}